export default "__VITE_ASSET__BVCrWFmv__"